/**
 * Форма предмета в плане. Круглым предмет делает каталог — флаг `round`, объём-цилиндр
 * или круглый ковёр, — а не равенство сторон: квадратная стиралка 600×600 и кровать,
 * которой сделали 1800×1800, остаются прямоугольными.
 */
import { RugShape, decorItemById } from "./sections";
import type { CatalogItem } from "./types";

export const isRoundItem = (item: CatalogItem | null): boolean =>
	item !== null &&
	(item.round === true ||
		item.view3d.type === "cylinder" ||
		decorItemById(item.id)?.rug?.shape === RugShape.Round);
